export default {
    apiKey: "AIzaSyDv0CktdqHPYc2qNAEVa9G_Ou9bGPX6Ib4",
    authDomain: "digital-mrv.firebaseapp.com",
    databaseURL: "https://digital-mrv.firebaseio.com",
    projectId: "digital-mrv",
    storageBucket: "digital-mrv.appspot.com",
    messagingSenderId: "1070862071095",
    appId: "1:1070862071095:web:7200c464573007b46896b2",
    webPushKey: "BBfjzQCESefkhxvU_hMkx-PVpLzmTu-qccdUouhwqOagHlPjtmys5McqubuExAB0HHFNI-OC9uJjE8iD3bX8xtE"
};